// extracted by mini-css-extract-plugin
export default {"container":"ValidationMessage_container__gQCIk"};